import { AvatarImage } from "./AvatarImage";

export default AvatarImage;
